import { FC, useMemo } from "react";
import { SelectInput } from "components/core";
import lodash from "lodash";
import {DistrictCodeCommunityMap, Communities} from "../apollo/data";


interface CommunityPickerProps {
  id: string;
  label?: string;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  labelHidden?: boolean;
  values: any;
  errors?: any;
  touched?: any;
  setFieldValue: any;
  setFieldTouched: any;
  setFieldError: any;
  handleChange: any;
  handleBlur: any;
  filter?: { regionCode?: string, districtCode?: string };
  position?: ("top" | "bottom");
  includeOther?: boolean;
}


export const CommunityPicker: FC<CommunityPickerProps> = ({
  id,
  label,
  filter,
  includeOther = true,
  ...form
}) => {

  const filteredOptions = useMemo(() =>

      filter?.districtCode
        ? lodash.get(DistrictCodeCommunityMap, filter.districtCode, [])
        : lodash.chain(Communities)
          .filter((comm) =>
            filter?.regionCode
              ? comm.regionCode === filter?.regionCode
              : true
          )
          .filter((comm) =>
            filter?.districtCode
              ? comm.districtCode === filter?.districtCode
              : true
          )
          .value()
    , [filter])

  return (
    <SelectInput
      id={id ?? "Community"}
      label={label ?? "Community"}
      placeholder="Select Community"
      options={[
        ...filteredOptions.map(
          (community: any) => ({
            label: community.name,
            value: community.name,
          })
        ),
        ...(includeOther ? [
          {
            label: "Other",
            value: "Other",
          }] : [])
      ]}
      {...form}
      disabled={form.disabled}
    />
  );
};